import { GENDER } from './common';

export interface ICreateQuickConsultReqBody {
  questionDetailInformation: {
    conditionDescription: string;
    diseasePictures: Array<string>;
    patientVo: {
      patientAge: number;
      patientGender: GENDER.Female | GENDER.Male;
      patientName: string;
    };
  };
}

export interface ITriageResultRes {
  departmentId: number;
  departmentName: string;
  icon?: string;
  serialNum?: string;
  subList?: string[];
  symptom?: string;
  timeout?: boolean;
}

export interface ICreateQuickConsultRes {
  triageId: number;
}

export interface IDepartment {
  departmentId: number;
  departmentName: string;
  icon: string;
  serialNum: number;
  symptom: string;
  subList: IDepartment[] | null;
}

export interface ITriageListResult {
  lastMark: boolean;
  list: ITriageListInfo[];
  pageNum: number;
  pageSize: number;
  total: number;
}

export interface ITriageListInfo {
  departmentId: string;
  departmentName: string;
  doctorId: number;
  createTime: string;
  finishTime: string;
  triageTime: string;
  id: number;
  status: number;
  userId: number;
  questionDetailInformation: IQuestionDetailInformation;
  productType: number;
  triageResultInfo: ITriageResultInfo;
}

export enum TriageListStatus {
  STAY_TRIAGE = 1,
  HAS_BEEN_EVALUATED = 2,
  CLOSED = 3,
  SKIN_CLOSED = 4
}

export interface ITriageDetail {
  departmentId: string;
  departmentName: string;
  doctorId: number;
  createTime: string;
  finishTime: string;
  triageTime: string;
  id: number;
  status: number;
  userId: number;
  questionDetailInformation: IQuestionDetailInformation;
  triageResultInfo: ITriageResultInfo;
  productType: number;
}

export interface ITriageResultInfo {
  departmentId: number;
  diseaseName: string;
  proposal: string;
}

export interface IConditionDescription {
  order: string;
  questions: string;
  answer: string;
}

export interface IQuestionDetailInformation {
  conditionDescription: string | IConditionDescription[];
  diseasePictures: string[];
  offlineSeenDoctor: boolean;
  patientVo: {
    birthday: string;
    currentCity: string;
    id: number;
    patientAge: number;
    patientGender: number;
    patientIdCardNo: string;
    patientMobile: string;
    patientName: string;
    userId: number;
    productType: number;
  };
}
